var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v(" サーベイ情報 ")]),_c('table',_vm._l((_vm.items),function(item,i){return _c('tr',{key:i},[_c('td',[_vm._v(_vm._s(item.label))]),_c('td',[_vm._v(_vm._s(item.value))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }